import { Country } from '../types/Country';
import { getCountryNameByLang } from './utils';
import {
  siteLang,
  LANG_FI,
  LANG_ENG,
  STATE_ACTIVE,
  STATE_INACTIVE,
  STATE_DEFAULT
} from './variables';

export interface FilterQuery {
  selectedCountry: Country | '';
  riskClass: string;
  continent: string;
  coverPolicy: string;
}

export const filter = (data: Country[], query: FilterQuery): Country[] => {
  const newState = [...data];
  const selectedCountry = query.selectedCountry;
  const queriedRiskClass = query.riskClass;
  const queriedContinent = query.continent.replace('\t', '');
  const coverPolicy = query.coverPolicy;

  for (const country of newState) {
    let matchesRiskClasses = true;
    let matchesContinents = true;
    let matchesCoverPolicies = true;

    if (coverPolicy) {
      matchesCoverPolicies = coverPolicy === country.classEng || coverPolicy === country.classFin;
    }
    if (queriedContinent) {
      switch (siteLang) {
        case LANG_FI: {
          matchesContinents = queriedContinent === country.riskAreaNameFin;
          break;
        }
        case LANG_ENG: {
          matchesContinents = queriedContinent === country.riskAreaNameEng;
          break;
        }
        default: {
          matchesContinents = queriedContinent === country.riskAreaNameFin;
          break;
        }
      }
    }
    if (queriedRiskClass) {
      matchesRiskClasses = queriedRiskClass === country.riskClass;
    }

    if (selectedCountry) {
      if (getCountryNameByLang(country) === getCountryNameByLang(selectedCountry)) {
        country.state = STATE_ACTIVE;
      }
      else {
        country.state = STATE_INACTIVE;
      }
    }
    else {
      if (matchesRiskClasses && matchesContinents && matchesCoverPolicies) {
        country.state = STATE_DEFAULT;
      }
      else {
        country.state = STATE_INACTIVE;
      }
    }
  }
  return newState;
}

export const selectCountry = (data: Country[], country: Country | null): Country[] => {
  const newState = [...data];
  for (const newCountry of newState) {
    if (country === newCountry) {
      newCountry.state = STATE_ACTIVE;
    }
    else {
      newCountry.state = STATE_INACTIVE;
    }
  }
  return newState;
}